/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import AppBar from 'material-ui-wrapper/lib/components/AppBar'
import Button from 'material-ui-wrapper/lib/components/Button'
import Card from 'material-ui-wrapper/lib/components/Card'
import CardActions from 'material-ui-wrapper/lib/components/Card/CardActions'
import CardContent from 'material-ui-wrapper/lib/components/Card/CardContent'
import CardHeader from 'material-ui-wrapper/lib/components/Card/CardHeader'
import CardMedia from 'material-ui-wrapper/lib/components/Card/CardMedia'
import Container from 'material-ui-wrapper/lib/components/Container'
import Drawer from 'material-ui-wrapper/lib/components/Drawer'
import Grid from 'material-ui-wrapper/lib/components/Grid'
import Link from 'material-ui-wrapper/lib/components/Link'
import Menu from 'material-ui-wrapper/lib/components/Menu'
import MenuItem from 'material-ui-wrapper/lib/components/Menu/MenuItemAdapter'
import Divider from 'material-ui-wrapper/lib/components/Menu/Divider'
import Select from 'material-ui-wrapper/lib/components/Select'
import Transition from 'material-ui-wrapper/lib/components/Transition'
import Icon from 'material-ui-wrapper/lib/icons'
import loader from './dynamicLoader'
import jss from './lazyLoadJss'

const { createTheme, ThemeProvider, useJss } = jss

export default {
  createTheme,
  ThemeProvider,
  useJss,
  AppBar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Checkbox: loader('Checkbox'),
  Container,
  Drawer,
  Grid,
  Heading: loader('Heading'),
  Icon,
  Link,
  Menu,
  MenuItem,
  Divider,
  Paper: loader('Paper'),
  Select,
  Transition,
}
